<template>
  <div>
    <Table
      :list="players"
    />
  </div>
</template>

<script>
import Table from '@/app/shared/components/list/table.vue';
import { GetAllPlayers } from '@/app/shared/services/playerService/playerService';

export default {
  name: 'Players',

  components: {
    Table,
  },

  data() {
    return {
      players: undefined,
      skipCount: 0,
      maxResultCount: 5,
      sorting: 'Name Asc',
    };
  },

  computed: {

  },

  watch: {

  },

  created() {

  },

  mounted() {
    GetAllPlayers(null, null, this.skipCount, this.maxResultCount, this.sorting).then((data) => {
      this.players = data;
    });
  },

  methods: {

  },

};
</script>
